require('datatables.net');
require('datatables.net-responsive');

import $ from 'jquery';

$.extend($.fn.dataTable.defaults, {
    searching: false,
    lengthChange: false,
    info: false,
    asStripeClasses: ['table__row--even', 'table__row--odd'],
    pagingType: 'numbers',
    language: {
        paginate: {
            next: 'następna',
            previous: 'poprzednia'
        },
        emptyTable: "Nie odnaleziono żadnych wyników.",
        zeroRecords: "Nie odnaleziono żadnych wyników."
    },
    columnDefs: [
      { targets: 'no-sort', orderable: false }
    ]
});

$.fn.dataTable.Responsive.breakpoints = [
    {name: 'desktop', width: Infinity},
    {name: 'tablet', width: 1199},
    {name: 'mobile', width: 767},
    {name: 'mobile-portrait', width: 479}
];

(function() {
    $('.datatable-checkbox').click(function() {
        $(this).toggleClass('datatable-checkbox--checked');
    });
})();
